const mainPath = process.env.REACT_APP_DB_HOST
// const mainPath = "http://119.205.233.209:5500"
// const mainPath = "http://3.36.159.224:5500"
// const mainPath = "http://127.0.0.1:5500"

export default mainPath